import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'pcg-tech-spec',
    templateUrl: './tech-spec.component.html',
    styleUrls: ['./tech-spec.component.scss'],
    standalone: false
})
export class TechSpecComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
